import { PRAYER_TYPE } from '@/src/features/pray/models/prayerIntentionType.enum'

import { INTENTION_TYPE } from './Intention.enums'

export const intentionPrayerTypeMap = {
  [INTENTION_TYPE.INTENTION]: PRAYER_TYPE.INTENTION,
  [INTENTION_TYPE.ARRIVAL]: PRAYER_TYPE.ARRIVAL,
  [INTENTION_TYPE.BIRTHDAY]: PRAYER_TYPE.BIRTHDAY,
} as const
